export default __webpack_public_path__ + "static/media/V375_22A375A.456dc618.STEP";